import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en";

// All UI texts live in ./locales/<language>/<namespace>.json.
// Components read them with: const { t } = useTranslation("districts"); t("addDistrict")
// Keys missing from a feature namespace fall back to "common".
i18n.use(initReactI18next).init({
  lng: "en",
  fallbackLng: "en",
  resources: { en },
  ns: Object.keys(en),
  defaultNS: "common",
  fallbackNS: "common",
  interpolation: { escapeValue: false }, // React already escapes rendered text
  initImmediate: false, // texts are bundled, so initialise synchronously
  react: { useSuspense: false },
});

export default i18n;
